import { render, staticRenderFns } from "./FavoriteProfile.vue?vue&type=template&id=89bb5baa&scoped=true"
import script from "./FavoriteProfile.vue?vue&type=script&lang=js"
export * from "./FavoriteProfile.vue?vue&type=script&lang=js"
import style0 from "./FavoriteProfile.vue?vue&type=style&index=0&id=89bb5baa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89bb5baa",
  null
  
)

export default component.exports